import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Process() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const timelineSteps = [
    {
      title: "Discussion",
      desc: "Understand goals, scope, and requirements with the client.",
      delay: 0,
    },
    {
      title: "Project Cost",
      desc: "Provide a detailed proposal and pricing aligned with requirements.",
      delay: 80,
    },
    {
      title: "Development",
      desc: "Agile sprints, code implementation, and continuous testing.",
      delay: 160,
    },
    {
      title: "Testing",
      desc: "Comprehensive QA, bug fixing, and client review.",
      delay: 240,
    },
    {
      title: "Delivery",
      desc: "Launch, deployment, and post-delivery support for seamless operations.",
      delay: 320,
    },
  ];

  const stackChips = [
    ".NET",
    "C#",
    "ASP.NET Core",
    "EF Core",
    "React",
    "Next.js",
    "Tailwind CSS",
    "Node.js",
    "Python",
    "Odoo",
    "PostgreSQL",
    "SQL Server",
    "Azure",
    "AWS",
    "Docker",
    "Kubernetes",
    "Redis",
    "RabbitMQ",
  ];

  return (
    <div>
      {/* PROCESS / TIMELINE */}
      <section
        id="process"
        className="section"
        style={{ background: "#f56e0b78", padding: "60px 0" }}
      >
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
            <h2
              className="section-title h1 fw-bold m-0 text-dark"
              data-aos="fade-right"
            >
              <i className="bi bi-bar-chart-steps me-2"></i>Professional
              Delivery Timeline
            </h2>
          </div>
          <p className="text-dark-50 mb-5" data-aos="fade-up">
            From initial discussion to final delivery, we follow a structured
            workflow to ensure your project is delivered efficiently, on time,
            and with exceptional quality.
          </p>

          <div className="timeline-horizontal d-flex flex-wrap justify-content-center position-relative gap-4">
            {timelineSteps.map((step, idx) => (
              <div
                key={idx}
                className="timeline-step text-center position-relative"
                data-aos="fade-up"
                data-aos-delay={step.delay}
              >
                <div className="t-bullet bg-primary mb-3"></div>
                <h5 className="fw-bold text-dark">{step.title}</h5>
                <p className="text-dark-50 small">{step.desc}</p>
              </div>
            ))}

            <div
              className="position-absolute w-100 d-none d-md-block"
              style={{
                top: 25,
                height: 3,
                background: "rgba(255,255,255,0.15)",
                left: 0,
                zIndex: -1,
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* STACK / CHIPS */}
      <section id="stack" className="section">
        <div className="container">
          <h2 className="section-title h1 fw-bold mb-4" data-aos="fade-right">
            <i className="bi bi-cpu me-2"></i>Our Stack
          </h2>
          <div className="d-flex flex-wrap gap-2" data-aos="fade-up">
            {stackChips.map((chip, idx) => (
              <span
                key={idx}
                className="badge rounded-pill text-bg-dark border"
              >
                {chip}
              </span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
